import styles from './Solucoes.module.css';
import ParticlesBackground from '../../components/ParticlesBackground/ParticlesBackground';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import {
  FaCode, FaLaptopCode, FaChartLine, FaDatabase,
  FaHashtag, FaPalette, FaBullhorn, FaScrewdriverWrench,
} from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import PageSEO from '../../components/PageSEO/PageSEO';

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 26 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
});

function Solucoes({ setActiveMenu }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.slice(0, 2) || 'pt';

  const services = [
    {
      Icon: FaCode,
      title: t('solucoes.s1'),
      desc: t('solucoes.s1Desc'),
    },
    {
      Icon: FaLaptopCode,
      title: t('solucoes.s2'),
      desc: t('solucoes.s2Desc'),
    },
    {
      Icon: FaChartLine,
      title: t('solucoes.s3'),
      desc: t('solucoes.s3Desc'),
    },
    {
      Icon: FaDatabase,
      title: t('solucoes.s4'),
      desc: t('solucoes.s4Desc'),
    },
    {
      Icon: FaHashtag,
      title: t('solucoes.s5'),
      desc: t('solucoes.s5Desc'),
    },
    {
      Icon: FaPalette,
      title: t('solucoes.s6'),
      desc: t('solucoes.s6Desc'),
    },
    {
      Icon: FaBullhorn,
      title: t('solucoes.s7'),
      desc: t('solucoes.s7Desc'),
    },
    {
      Icon: FaScrewdriverWrench,
      title: t('solucoes.s8'),
      desc: t('solucoes.s8Desc'),
      route: '/TIPresencial',
    },
  ];

  const goContato = () => {
    setActiveMenu?.('Contato');
    navigate('/Contato');
  };

  return (
    <>
      <PageSEO
        title="Serviços"
        description="SteinSoft oferece: terceirização Delphi, software por encomenda, consultoria em TI, gestão de banco de dados, social media, design gráfico e marketing digital."
        path="/Servicos"
        lang={lang}
      />
      <div className={styles.particles}>
        <ParticlesBackground />
      </div>

      <div className={styles.page}>

        {/* ── Hero ── */}
        <section className={styles.hero}>
          <motion.span className={styles.eyebrow} {...reveal()}>
            {t('solucoes.eyebrow')}
          </motion.span>
          <motion.h1 className={styles.heroTitle} {...reveal(0.1)}>
            {t('solucoes.tituloBase')} <span className={styles.accent}>{t('solucoes.tituloAcc')}</span>
          </motion.h1>
          <motion.p className={styles.heroSub} {...reveal(0.2)}>
            {t('solucoes.subtitulo')}
          </motion.p>
        </section>

        {/* ── Grid de serviços ── */}
        <section className={styles.section}>
          <div className={styles.grid}>
            {services.map((s, i) => (
              <motion.div
                key={i}
                className={`${styles.card} ${s.route ? styles.cardClickable : ''}`}
                {...reveal(i * 0.07)}
                onClick={() => s.route && navigate(s.route)}
              >
                <div className={styles.iconWrap}>
                  <s.Icon />
                </div>
                <h3 className={styles.cardTitle}>{s.title}</h3>
                <p className={styles.cardDesc}>{s.desc}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* ── CTA ── */}
        <motion.section className={styles.cta} {...reveal(0.1)}>
          <h2 className={styles.ctaTitle}>{t('solucoes.ctaTitulo')}</h2>
          <p className={styles.ctaSub}>{t('solucoes.ctaDesc')}</p>
          <button className={styles.ctaBtn} onClick={goContato}>
            {t('solucoes.ctaBtn')}
          </button>
        </motion.section>

      </div>
    </>
  );
}

export default Solucoes;
